import { z } from "zod";

export { ZodError } from "zod";

const processNameRegex = /^[a-z0-9-]+$/;

export const schema = z.object({
  name: z
    .string("Nome é obrigatório")
    .min(1, "Nome é obrigatório")
    .max(255, "Nome não deve ultrapassar 255 caracteres")
    .refine((name) => name.trim().length > 0, {
      message: "Nome não pode conter apenas espaços em branco",
    })
    .regex(processNameRegex, {
      message: "Nome deve conter apenas letras minúsculas, números e hífens",
    }),
  displayName: z
    .string("Nome de exibição é obrigatório")
    .min(1, "Nome de exibição é obrigatório")
    .max(255, "Nome de exibição não deve ultrapassar 255 caracteres")
    .refine((val) => val.trim().length > 0, {
      message: "Nome de exibição não pode conter apenas espaços em branco",
    }),
  plannedTimes: z.object({
    plannedExecutionStart: z.string("Hora de início é obrigatória"),
    plannedExecutionEnd: z.string("Hora de término é obrigatória"),
    sharepointFolderName: z
      .string("Nome da pasta é obrigatória")
      .min(1, "Nome da pasta é obrigatório")
      .max(255, "Nome da pasta não deve ultrapassar 255 caracteres"),
    isOneShot: z.boolean().optional(),
  }),
  description: z
    .string()
    .max(250, "Descrição não deve ultrapassar 250 caracteres")
    .optional()
    .nullable(),
  linkDocumentation: z
    .string()
    .max(500, "Link não deve ultrapassar 500 caracteres")
    .optional()
    .nullable(),
});
